import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-lg-100 w-sm-90 w-xs-90 mt-10 mt-lg-15 mx-lg-auto mx-sm-auto mx-xs-auto" }
const _hoisted_2 = { class: "w-lg-80 mx-auto" }
const _hoisted_3 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Upgrade a Plan"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-5" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "link-primary fw-bolder"
    }, "Pricing Guidelines"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_6 = { class: "row g-10 d-flex justify-content-center" }
const _hoisted_7 = { class: "d-flex h-100 align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plan_card = _resolveComponent("plan-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPlans, (plan, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-md-6 col-lg-4 col-xl-3",
                key: index
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_plan_card, {
                    services: _ctx.planServices,
                    frequency: _ctx.current,
                    plan: plan,
                    onSelect: _ctx.subscribePlan
                  }, null, 8, ["services", "frequency", "plan", "onSelect"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}